export default __webpack_public_path__ + "static/media/Shri Praveen Roy.9957e89d.jpeg";